import { useAudioFeatureFlags } from '@confluence/audio/entry-points/useAudioFeatureFlags.ts';

export const useHasAudioButton = (isAIEnabledForContent: boolean): boolean => {
	const { isAIPolicyAndBrowserSupportEnabled, isAudioBylineEntrypointEnabled } =
		useAudioFeatureFlags();
	// Only show audio entrypoint in sidebar if:
	// 1. AI is Enabled for content
	// 2. AI Policy and browser support are enabled AND
	// 3. The when byline entrypoint is not enabled (ex: Audio V2 experience), the object sidebar will be the only audio entrypoint.
	return (
		isAIEnabledForContent && isAIPolicyAndBrowserSupportEnabled && !isAudioBylineEntrypointEnabled
	);
};
